import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTcfDeclarationsGet = {
    path: "/tcf/declarations",
    method: RouteHttpVerb.GET
};
export { locationRestTcfDeclarationsGet };
